var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"folder-item-view-3-account-view"},[(_vm.accountId)?_c('YourAccountHelperComponents1MainPage',{attrs:{"accountId":_vm.accountId,"isPublicAccountViewing":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }